import React from 'react';
import Helmet from '../components/Helmet';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import { ChevronRight, ChevronLeft } from 'lucide-react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import Fetch from '../components/Fetch';
import Card from '../components/Card';
import ArticleList from '../components/ArticleList';

const Home = () => {
  return (
    <>
      <Helmet />
      <Fetch>
        {({ data, loading, error }) => {
          if (loading) return <p>Loading...</p>;
          if (error) return <p>Error loading data.</p>;

        // Sort contentList by date_updated in descending order
        const sortedContentList = (data || []).sort((a, b) => new Date(b.date_created) - new Date(a.date_created));

        // Get the latest 5 items for the Card component
        const latestFive = sortedContentList.slice(0, 5);

        // Get the remaining items for the ArticleList component
        const remainingArticles = sortedContentList.slice(5);

        return (
          <div className="p-4">
            <div className="custom-navigation">
              <button className="swiper-prev">
                <ChevronLeft size={35} strokeWidth={3} />
              </button>
              <button className="swiper-next">
                <ChevronRight size={35} strokeWidth={3} />
              </button>
            </div>
            <Swiper
              slidesPerView={1}
              spaceBetween={20}
              navigation={{
                nextEl: '.swiper-next',
                prevEl: '.swiper-prev',
              }}
              pagination={{
                clickable: true,
                el: '.custom-pagination',
              }}
              breakpoints={{
                1024: {
                  slidesPerView: 3,
                  spaceBetween: 10,
                },
              }}
              modules={[Navigation, Pagination]}
              className="mySwiper"
            >
              {latestFive.map((item, index) => (
                <SwiperSlide key={index}>
                  <Card
                    type={item.content_type}
                    title={item.article_title || 'Untitled'}
                    description={
                      item.article_content
                        ? item.article_content.replace(/<[^>]+>/g, '').slice(0, 100) + '...'
                        : 'No description available.'
                    }
                    slug={item.slug}
                    article={item}  // Add this line to pass the full article data
                  />
                </SwiperSlide>
              ))}
            </Swiper>
            <div className="custom-pagination"></div>
            <div className="home-article-list-cont">
              <ArticleList articles={remainingArticles} />
            </div>
          </div>
        );
      }}
    </Fetch>
    </>
  );
};

export default Home;